import React from 'react'
import { useState } from 'react'
import AdAllMovies from './AdAllMovies'
import GetAllTheatres from './GetAllTheatres'
import './AdminHome.css'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'


function AdminHome() {

    const [page, setPage] = useState("Movies")
    const storedAdmin = JSON.parse(localStorage.getItem("adminData"));
    const [logStatus, setLogStatus] = useState(true);
    const navigate = useNavigate();
    
    useEffect(()=> {
        if(!storedAdmin){
            setLogStatus(false)
            return
        }
    },[storedAdmin])

    const handleLogout = ()=>{
        localStorage.removeItem("adminData");
        navigate('/login');
    }
  return (
    <>
    { (!logStatus) ? "Unauthorised access." : <div className="admin-container">
        <div className="adminnav">
                <div className="logoName">
                    <div className="logo">
                        <img width="40" height="40" src="https://img.icons8.com/stickers/40/movie-projector.png" alt="movie-projector"/>
                    </div>
                    <div className="name">Show box</div>
                </div>
        </div>
        <div className='adminContainer'>    
            <div className="sideBar">
                <div className="heading">Welcome, Admin</div>
                <button onClick={()=>{setPage("Movies")}} className="sideBtns"> 
                <i className='fa-solid fa-film'></i> &nbsp; Movies</button>
                <button onClick={()=>{setPage("Theatres")}} className="sideBtns">
                <i className='fa-solid fa-building'></i> &nbsp; Theatres</button>
                <button onClick={handleLogout} className="sideBtns">
                <i className="fa-solid fa-right-from-bracket"></i> &nbsp; Logout</button>
            </div>
            <div className="infoContainer">
                {(page === "Movies") && <AdAllMovies /> }
                {(page === "Theatres") && <GetAllTheatres />}
            </div>

        </div>
    </div>}
    </>
  )
}

export default AdminHome
